var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 137,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#pin_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#pin_svg__b)",
    d: "M15 56h3v80h-3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#pin_svg__c)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#pin_svg__d)",
    strokeWidth: 3,
    d: "M15 8h3v60h-3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#pin_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#pin_svg__f)",
    strokeWidth: 3,
    d: "M15 8h3v60h-3z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#pin_svg__g)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    x: 25,
    y: 48,
    fill: "url(#pin_svg__h)",
    rx: 8.5,
    transform: "rotate(90 25 48)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#pin_svg__i)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    x: 25,
    y: 48,
    fill: "url(#pin_svg__j)",
    rx: 8.5,
    transform: "rotate(90 25 48)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pin_svg__b",
    x1: 16.5,
    x2: 16.5,
    y1: 56,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pin_svg__d",
    x1: 16,
    x2: 16,
    y1: 68.071,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    stopColor: "#181B25",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322,
    stopColor: "#181B25",
    stopOpacity: 0.131
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789,
    stopColor: "#96C5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#05DF54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pin_svg__f",
    x1: 16,
    x2: 16,
    y1: 68.071,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    stopColor: "#181B25",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322,
    stopColor: "#181B25",
    stopOpacity: 0.131
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789,
    stopColor: "#96C5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#05DF54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pin_svg__h",
    x1: 27.665,
    x2: 46.633,
    y1: 84.512,
    y2: 81.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05DF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#96C5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pin_svg__j",
    x1: 27.665,
    x2: 46.633,
    y1: 84.512,
    y2: 81.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05DF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#96C5F0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pin_svg__a",
    width: 5,
    height: 82,
    x: 14,
    y: 55,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4767_219823",
    stdDeviation: 0.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pin_svg__c",
    width: 8,
    height: 65,
    x: 12.5,
    y: 5.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4767_219823",
    stdDeviation: 0.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pin_svg__e",
    width: 18,
    height: 75,
    x: 7.5,
    y: 0.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4767_219823",
    stdDeviation: 3
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pin_svg__g",
    width: 19,
    height: 19,
    x: 7,
    y: 47,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4767_219823",
    stdDeviation: 0.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pin_svg__i",
    width: 33,
    height: 33,
    x: 0,
    y: 40,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4767_219823",
    stdDeviation: 4
  })))));
};
export default SvgPin;